export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtReklamatext';
export const NAME = 'ReklamniText';
